import React, { useState, useEffect } from 'react';

const LOCAL_KEY = 'bannerConfig';

export default function BannerConfigForm({ onSave }) {
  const [text, setText] = useState('');
  const [color, setColor] = useState('#007bff');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_KEY);
    if (saved) {
      try {
        const { text, color, endDate } = JSON.parse(saved);
        setText(text || '');
        setColor(color || '#007bff');
        setEndDate(endDate || '');
      } catch {}
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const config = { text, color, endDate };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(config));
    if (onSave) onSave(config);
    alert('Bannière enregistrée !');
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 mb-8">
      <h3 className="text-xl font-bold mb-4 text-[#2f3b52]">Configurer la bannière</h3>
      <div className="mb-3">
        <label className="block text-sm font-semibold mb-1">Texte</label>
        <input type="text" value={text} onChange={e => setText(e.target.value)} className="w-full border rounded px-3 py-2" required />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-semibold mb-1">Couleur de fond</label>
        <input type="color" value={color} onChange={e => setColor(e.target.value)} className="w-12 h-8 p-0 border rounded" />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-semibold mb-1">Date de fin (optionnel)</label>
        <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="border rounded px-3 py-2" />
      </div>
      <button type="submit" className="bg-[#2f3b52] text-white px-6 py-2 rounded font-bold hover:bg-[#3d4e68] transition-colors">Enregistrer</button>
    </form>
  );
}
